import { render, staticRenderFns } from "./ConfirmReceived.vue?vue&type=template&id=b8aae11a&scoped=true&"
import script from "./ConfirmReceived.vue?vue&type=script&lang=js&"
export * from "./ConfirmReceived.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmReceived.vue?vue&type=style&index=0&id=b8aae11a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8aae11a",
  null
  
)

export default component.exports